import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const StyledFilterHeading = styled.p`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])}
    margin-bottom: 8px;
`;

export const FlexRowWrap = styled(FlexRow)`
    flex-wrap: wrap;
`;
